import { appConfig } from '../logic/appConfigProvider';
import { urls } from '../logic/urls';
import { urlCombine, getBaseUriWithoutParameters } from '../utils/misc';

export const azureAdMsalConfig = {
    auth: {
        authority: 'https://login.microsoftonline.com/common',
        clientId: appConfig.azureAdMsalClientId,
        navigateToLoginRequestUrl: false,
        redirectUri: urlCombine(getBaseUriWithoutParameters(), urls.postLogin)
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (
                level,
                message,
                containsPii
            ) => {
                if (containsPii) {
                    return;
                }
                
                console.info(message);
            },
            piiLoggingEnabled: false,
        }
    }
}

// Entra External ID (CIAM) MSAL configuration
export const ciamMsalConfig = {
    auth: {
        authority: 'https://robinciamid.ciamlogin.com/8b3c2ea1-1732-47fc-ac4c-c7c72e1297a1',
        clientId: appConfig.ciamMsalClientId,
        knownAuthorities: ['robinciamid.ciamlogin.com'],
        navigateToLoginRequestUrl: false,
        redirectUri: urlCombine(getBaseUriWithoutParameters(), urls.postLogin),
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;
                console.info(message);
            },
            piiLoggingEnabled: false,
        },
    },
};